import { apiSlice } from "./apiSlice";
import { getCurrency, setCurrenciesSelection } from "../slice/currencySlice";

export const currencyApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getCurrency: builder.query({
      providesTags: ["Currency"],
      query: params => (params ? `/api_currency/currency/?${params}` : "/api_currency/currency/"),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getCurrency(result.data))).catch(error => {});
      },
    }),
    getCurrencySelection: builder.query({
      providesTags: ["Currency"],
      query: params =>
        params
          ? `/api_currency/currency/?type=selection&${params}`
          : "/api_currency/currency/?type=selection",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setCurrenciesSelection(result.data)))
          .catch(error => {});
      },
    }),
  }),
});

export const {
  useGetCurrencyQuery,
  useLazyGetCurrencySelectionQuery,
  useGetCurrencySelectionQuery,
} = currencyApiSlice;
